import { organizationConstants } from "../../../constants/organization.constants";

export function organization(state = {}, action) {
  switch (action.type) {
    case organizationConstants.UPDATE_ORGANIZATION_REQUEST:
      return { ...state, loading: true };
    case organizationConstants.UPDATE_ORGANIZATION_SUCCESS:
      return { ...state, loading: true };
    case organizationConstants.UPDATE_ORGANIZATION_FAILURE:
      return { ...state, loading: true };

    case organizationConstants.GET_ORGANIZATION_BY_USER_REQUEST:
      return { ...state, loading: true };
    case organizationConstants.GET_ORGANIZATION_BY_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        organizationList: action.organizationList
      };
    case organizationConstants.GET_ORGANIZATION_BY_USER_FAILURE:
      return { ...state, loading: false, error: action.error };

    case organizationConstants.GET_ORGANIZATION_DETAILS_SUCCESS:
    case organizationConstants.UPDATE_ORGANIZATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        orgDetails: action.details,
        roles: action.roles,
        modules: action.modules
      };
    case organizationConstants.GET_ORGANIZATION_USERS_SUCCESS:
    case organizationConstants.UPDATE_ORGANIZATION_USERS_SUCCESS:
      return { ...state, loading: false, orgUsers: action.users };
    case organizationConstants.GET_ORGANIZATION_SUBS_SUCCESS:
    case organizationConstants.UPDATE_ORGANIZATION_SUBS_SUCCESS:
      return { ...state, loading: false, subOrganizations: action.subOrgs };
    case organizationConstants.GET_ORGANIZATION_SETTINGS_SUCCESS:
    case organizationConstants.UPDATE_ORGANIZATION_SETTINGS_SUCCESS:
      return { ...state, loading: false, orgSettings: action.settings };
    default:
      return state;
  }
}
